$(document).ready(function () {
    $("<h2>LASTEST POST:</h2>").insertBefore(".four.columns.article.clearfix:nth-child(2) .sub_title");

});
// Shortcircuit variable
let triggered = false;

function ScrollExecute() {
    // Locate loadmore button
    let moreButon = $('#more').last();

    // Get URL from the loadmore button
    let nextUrl = $(moreButon).find('a').attr("href");

    // Button position when AJAX call should be made one time
    if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggered == false)) {

        // Trigger shortcircuit to ensure AJAX only fires once
        triggered = true;

        // Make ajax call to next page for load more data
        $.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function () {
                moreButon.remove();
            }
        })
            .done(function (data) {
                // Append data
                $('.product').append($(data).find('.product').html());

                // On success, reset shortcircuit
                triggered = false
            });
    }
    var request = new XMLHttpRequest();
    request.open("GET", "");
    request.onload = function () {
        SPR.registerCallbacks();
        SPR.initRatingHandler();
        SPR.initDomEls();
        SPR.loadProducts();
        SPR.loadBadges();
    };
    request.send();
}


$(document).ready(function ($) {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('#backToTop').fadeIn('slow');
        } else {
            $('#backToTop').fadeOut('slow');
        }
    });
    $('#backToTop').click(function () {
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    });
});


$(document).ready(function () {


    $('.featured-promotions-section .section').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function () {
        $('.featured-promotions-section .section').slick('resize');
    });


});

$(document).ready(function () {


    $('.related-product-column .products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        dots: false,

        slide: '.thumbnail',
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function () {
        $('.related-product-column .products').slick('resize');
    });


});


$(document).load(function () {
    //$('.STP-tier-block .STP-tier-block-lines').prepend('QTY3  &nbsp;&nbsp;&nbsp;&nbsp;   Price &nbsp;&nbsp;&nbsp;&nbsp; SAVE<br>');
});
/*
function checkOffset() {
    if($('.theme-background-color theme-text-color').offset().top + $('.theme-background-color theme-text-color').height() 
                                           >= $('#shopify-section-footer').offset().top - 10)
        $('.theme-background-color theme-text-color').css('position', 'absolute');
    if($(document).scrollTop() + window.innerHeight < $('#shopify-section-footer').offset().top)
        $('.theme-background-color theme-text-color').css('position', 'fixed'); // restore when you scroll up
    $('.theme-background-color theme-text-color').text($(document).scrollTop() + window.innerHeight);
}
$(document).scroll(function() {
    checkOffset();
});*/



$(document).ready(function () {

    var price = $('.product-column-top .modal_price .current_price .money').text();
    var pp = price.replace("£", "")

    var vat = ("£" + (pp * 1.2).toFixed(2));

    $('.product-column-top .modal_price .ex-vat-price').text(vat);

    window.updateTaxText = () => {
        var price = $('.product-column-top .modal_price .current_price .money,.product-column-top .modal_price .current_price .ymq-price-span').text();
        var pp = price.replace("£", "")
        // console.log(pp);
        var vat = ("£" + (pp * 1.2).toFixed(2));

        var acvat = parseFloat((pp * 1.2).toFixed(2)) - parseFloat(pp);

        // console.log(acvat.toFixed(2));
        $('.product-column-top .modal_price .ex-vat-price').text(vat);
    }

    $('form.product_form_options').change(function () {
        updateTaxText()
    });



});

jQuery(document).ready(function ($) {
    var totaalBreedte = '750.0';
    var menuBreedte = '400.10';
    var over = totaalBreedte - menuBreedte;

    console.log(over);
});